import React from 'react';
import { getCovidTestResultTime, SampleAnalysisTypes } from '../../util';
import SampleAnalysisBulletPoint from './SampleAnalysisBulletPoint';
import ResultTimeBulletPoint from './ResultTimeBulletPoint';
import BothTypesOfResultTimeBulletPoints from './BothTypesOfResultTimeBulletPoints';
import IncreasedDemandBulletPoint from './IncreasedDemandBulletPoint';
import ClinicProvideInfoBulletPoint from './ClinicProvideInfoBulletPoint';

type Props = {
  details: any;
};

const SampleAnalysis = ({ details }: Props) => {
  const inHouseResultTime = getCovidTestResultTime(details, SampleAnalysisTypes.IN_HOUSE);
  const sendOutResultTime = getCovidTestResultTime(details, SampleAnalysisTypes.SEND_OUT);

  return (
    <>
      <SampleAnalysisBulletPoint details={details} />

      <ResultTimeBulletPoint
        details={details}
        inHouseResultTime={inHouseResultTime}
        sendOutResultTime={sendOutResultTime}
      />

      <BothTypesOfResultTimeBulletPoints
        inHouseResultTime={inHouseResultTime}
        sendOutResultTime={sendOutResultTime}
      />

      <IncreasedDemandBulletPoint />

      <ClinicProvideInfoBulletPoint />
    </>
  );
};

export default SampleAnalysis;
